

$(function(){

    mySpMenuCtr=new SpMenuCtr();
    mySpMenuCtr.init();
    console.log("call ok");

});



//
//sp menu btn ctr
//


var SpMenuCtr=(function(){

    state='';

    var SpMenuCtr=function(){
        $('.spGlobalHeader__menuBtn img').click(function(){
            mySpMenuCtr.clickMenu();
        });
    };


    SpMenuCtr.prototype.init=function(){
        mySpMenuCtr.state='hide';
    }

    SpMenuCtr.prototype.clickMenu=function(){

        if(mySpMenuCtr.state=='hide'){
            this.showMenu();
        }else{
            this.hideMenu();
        }
    }


    SpMenuCtr.prototype.showMenu=function(){
        TweenMax.to('.spGlobalMenu',0.4, {
            top:'60px',
            ease: Expo.easeOutQuint,
            onComplete: function() {
                mySpMenuCtr.state='show';
            }
        });
    }

    SpMenuCtr.prototype.hideMenu=function(){
        TweenMax.to('.spGlobalMenu',0.6, {
            top:'-500px',
            ease: Expo.easeInExpo,
            onComplete: function() {
                mySpMenuCtr.state='hide';
            }
        });
    }


    return SpMenuCtr;

})();
